module.exports = __webpack_public_path__ + "static/img/v2_pt9rqt.8dc7713.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v2_pt9rqt.jpg
// module id = 66u5
// module chunks = 2